export const getMetaDataOptions = (isCreateMode?: boolean) => {
  const options = [
    "Customer",
    "Account",
    "SupportCase",
    "Lead",
    "Prospect",
    "Contact",
    "Order",
    "Opportunity",
    "Transaction",
    "Products",
    "ReturnAuthorization",
    "Estimate",
    "InventoryItem",
  ].sort();

  return isCreateMode ? ["Select a NetSuite record", ...options] : options;
};